module.exports = __webpack_public_path__ + "img/img_kv_head_w.91e960e7.png";